import { render, staticRenderFns } from "./InformationVolunteerBangkok.vue?vue&type=template&id=6b82f12c&scoped=true"
import script from "./InformationVolunteerBangkok.vue?vue&type=script&lang=js"
export * from "./InformationVolunteerBangkok.vue?vue&type=script&lang=js"
import style0 from "./InformationVolunteerBangkok.vue?vue&type=style&index=0&id=6b82f12c&prod&scoped=true&lang=css"
import style1 from "./InformationVolunteerBangkok.vue?vue&type=style&index=1&id=6b82f12c&prod&lang=css"
import style2 from "./InformationVolunteerBangkok.vue?vue&type=style&index=2&id=6b82f12c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b82f12c",
  null
  
)

export default component.exports